import styled, { css } from 'styled-components'
import { TBodyTR } from 'src/components/TableComponents/style'

export const Wrapper = styled.div`
  flex: 1.5;
  width: 100%;
  padding: 0 20px;
  pointer-events: all;
`

export const Title = styled.h2<{ clicked: boolean }>`
  text-align: center;
`

export const TableBodyRow = styled(TBodyTR)`
  cursor: pointer;
  ${({ clicked }) => clicked
    && css`
      background-color: #ff1744 !important;
      color: #ffffff;
    `};
`
